__turbopack_context__.v({
  "breadcrumb": "webstorieslist-module-scss-module__cPXEHq__breadcrumb",
  "container": "webstorieslist-module-scss-module__cPXEHq__container",
  "endMessage": "webstorieslist-module-scss-module__cPXEHq__endMessage",
  "errorContainer": "webstorieslist-module-scss-module__cPXEHq__errorContainer",
  "fadeLink": "webstorieslist-module-scss-module__cPXEHq__fadeLink",
  "heading": "webstorieslist-module-scss-module__cPXEHq__heading",
  "loading": "webstorieslist-module-scss-module__cPXEHq__loading",
  "loadingMore": "webstorieslist-module-scss-module__cPXEHq__loadingMore",
  "noStories": "webstorieslist-module-scss-module__cPXEHq__noStories",
  "retryButton": "webstorieslist-module-scss-module__cPXEHq__retryButton",
  "storiesList": "webstorieslist-module-scss-module__cPXEHq__storiesList",
});
